export const route = Object.freeze({
  accrualsWizard: 'accruals-wizard',
  finalizePayPeriod: 'finalize-pay-period',
  integrations: 'integrations',
  policy: 'policy',
  policies: 'policies',
  shiftSwap: 'shiftSwap',
  timecardReview: 'timecard-review',
  timeCard: 'timecard',
  timeOff: 'timeoff',
  webclock: 'webclock',
  webaccess: 'webaccess',
  linksanddocs: 'linksanddocs',
  zayzoon: 'zayzoon',
});

export const target = Object.freeze({
  self: 'self',
  blank: 'blank',
  local: 'local',
});

// Links builders
export const getAccrualsWizardLink = (id, step) => {
  if (step) {
    return `/${route.accrualsWizard}/${id}/${step}`;
  }
  return `/${route.accrualsWizard}/${id}`;
};

export const getAccrualsWizardEditLink = (id, step, subStep = null) => {
  if (subStep) {
    return `/${route.accrualsWizard}/${id}/${step}/${subStep}/edit`;
  }
  return `/${route.accrualsWizard}/${id}/${step}/edit`;
};
